import { render, staticRenderFns } from "./ClockIcon.vue?vue&type=template&id=ef6a5f1e"
import script from "./ClockIcon.vue?vue&type=script&lang=ts"
export * from "./ClockIcon.vue?vue&type=script&lang=ts"
import style0 from "./ClockIcon.vue?vue&type=style&index=0&id=ef6a5f1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports